import { v4 as uuidv4 } from "uuid";
import CampaignRepository from "../domain/data/CampaignRepository";
import Campaign from "../domain/entities/Campaign";
import User from "../domain/entities/User";
import { campaigns, myDocuments } from "./InitData";
import SigningDocument from "../domain/entities/_SigningDocument";
import Document, { DocumentStatus } from "../domain/entities/Document";

export default class MockCampaignRepository implements CampaignRepository {
  private static campaigns: Campaign[] = campaigns;
  private static myDocuments: Document[] = myDocuments;

  async saveCampaign(user: User, campaign: Campaign): Promise<Campaign> {
    if (!campaign.id) {
      campaign.id = uuidv4();
      if (!campaign.package!.id) campaign.package!.id = uuidv4();

      if (!campaign.package!.documentTemplates[0].id)
        campaign.package!.documentTemplates.map((item) => (item.id = uuidv4()));

      if (!campaign.signatoryGroup!.id) campaign.signatoryGroup!.id = uuidv4();
      //MockCampaignRepository.campaigns.push(campaign);
      return campaign;
    } else {
      const record = MockCampaignRepository.campaigns.find(
        (record) => record.id === campaign.id
      );
      if (record) {
        record.name = campaign.name;
        record.description = campaign.description;
        record.package = campaign.package;
        record.signatoryGroup = campaign.signatoryGroup;
        record.startDate = campaign.startDate;
        record.endDate = campaign.endDate;
      }
      return record as Campaign;
    }
  }

  async getCampaigns(user: User): Promise<Campaign[]> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(MockCampaignRepository.campaigns);
      }, 2000);
    });
  }

  async getCampaignsbyLookup(user: User): Promise<Campaign[]> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(MockCampaignRepository.campaigns);
      }, 2000);
    });
  }

  public async getCampaignsPagination(
    user: User
  ): Promise<{ items: Campaign[]; lastEvaluatedKey?: any }> {
    throw new Error("Method not implemented.");
  }

  async getAllCampaigns(user: User): Promise<Campaign[]> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(MockCampaignRepository.campaigns);
      }, 2000);
    });
  }
  
  public async getCampaignsByLookupPagination(
    user: User
  ): Promise<{ items: Campaign[]; lastEvaluatedKey?: any }> {
    throw new Error("Method not implemented.");
  }
  
  public async getCampaignsCount(
    user: User
  ): Promise<number> {
    throw new Error("Method not implemented.");
  }

  public async getCampaignsLookupsCount(
    user: User
  ): Promise<number> {
    throw new Error("Method not implemented.");
  }
  
  async deleteCampaign(user: User, campaign: Campaign): Promise<Boolean> {
    const record = MockCampaignRepository.campaigns.find(
      (record) => record.id === campaign.id
    );
    if (record) {
      MockCampaignRepository.campaigns =
        MockCampaignRepository.campaigns.filter(
          (record) => record.id !== campaign.id
        );
      return true;
    }
    return false;
  }

  async sendCampaign(
    user: User,
    campaign: Campaign
  ): Promise<string | undefined> {
    /*const record = MockCampaignRepository.campaigns.find(
      (record) => record.id === campaign.id
    );
    if (record) {
      MockCampaignRepository.campaigns =
        MockCampaignRepository.campaigns.filter(
          (record) => record.id !== campaign.id
        );
      return campaign.id;
    }
    return undefined;*/
    const documentData: Document = {
      id: uuidv4(),
      documentTemplate: campaign.package?.documentTemplates[0]!,
      signatory: campaign.signatoryGroup?.signatories[0]!,
      campaign: campaign,
      file: campaign.package?.documentTemplates[0].signaturePositionFile,
      status: DocumentStatus.PENDING,
    };
    MockCampaignRepository.myDocuments.push(documentData);
    console.log(campaign);
    return "";
  }

  async getCampaign(user: User, campaignId: string): Promise<Campaign> {
    throw new Error("Method not implemented.");
  }
  
  async saveSendCampaign(user: User, campaign: Campaign): Promise<boolean> {
    throw new Error("Method not implemented.");
  }

  async getCampaignExt(shortId: string): Promise<Campaign> {
    throw new Error("Method not implemented.");
  }

  async getSigningDocument(
    user: User,
    campaign: Campaign
  ): Promise<SigningDocument[]> {
    throw new Error("Method not implemented.");
  }

  async getCampaignEmailTracking(
    user: User,
    campaign: Campaign
  ): Promise<{ tracking: any; stats: any }> {
    throw new Error("Method not implemented.");
  }
}
